module.exports = __webpack_public_path__ + "img/LTS_Test.05ced179.gif";